import { GuestCheckoutAPI } from "../../../common/constants/guest-checkout-api";
import { getUserPromoCodeDiscountMagento, removeUserPromoCodeDiscountMagento } from "../../../common/constants/shop-api";
import environment, { CheckoutFlow } from "../../../common/environment";
import { getResponseData } from "../../../common/utils/api-utils";
import { DiscountDetails } from "../interfaces/promo-code.interface";

/*----- API CALLS ------*/

export async function getPromoCodeDiscountMagentoApiCall(promoCode: string, token?: string, checkoutFlow?: CheckoutFlow): Promise<DiscountDetails> {
  const url = new URL(environment().magentoUrl + getUserPromoCodeDiscountMagento(promoCode, checkoutFlow));
  return await getResponseData(
    new Request(url.toString(), {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : `Bearer ${token}`
      },
    }));
}

export async function deletePromoCodeDiscountMagentoApiCall(token?: string): Promise<DiscountDetails> {
  const url =  new URL(environment().magentoUrl + removeUserPromoCodeDiscountMagento());
  return await getResponseData(
    new Request(url.toString(), {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : `Bearer ${token}`
      },
    }));
}

export async function getPromoCodeDiscountMagentoApiCallGuestCheckout(promoCode: string, cartId: string): Promise<DiscountDetails> {
  const url =  new URL(environment().magentoUrl + GuestCheckoutAPI.applyPromoCode(cartId, promoCode));
  return await getResponseData(
    new Request(url.toString(), {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
    }));
}

export async function deletePromoCodeDiscountMagentoApiCallGuestCheckout(cartId: string): Promise<DiscountDetails> {
  const url =  new URL(environment().magentoUrl + GuestCheckoutAPI.removePromoCode(cartId));
  return await getResponseData(
    new Request(url.toString(), {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
    }));
}
